import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 32 32"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", { d: "m16 0 16 16-16 16-2.1-2.1 12.4-12.4H0v-3h26.3L13.9 2.1z" }, null, -1)
  ]));
}
const ArrowRight = { render };
export {
  ArrowRight as default,
  render
};
//# sourceMappingURL=ArrowRight.svg.js.map
